import { Component, OnInit, HostBinding, ElementRef } from '@angular/core';

@Component({
  selector: 'card-container',
  templateUrl: './card-container.component.html',
  styleUrls: ['./card-container.component.scss']
})
export class CardContainerComponent implements OnInit {

  constructor(private ref: ElementRef) { }

  @HostBinding('class')
  private get class(): string {
    return this.ref.nativeElement.getElementsByTagName('card').length > 3 ? 'max-2' : 'max-1';    
  }


  ngOnInit(): void {
  }

}
